import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React, { useState } from 'react';
import { CustomerHappinessIndexUi } from './ui/CustomerHappinessIndexUi';
import { Spinner, useAnalyticsActionTracker } from '@cp-shared-15/frontend-ui';
import { CpDataApi } from '../../cp-xhr';
import { CustomerHappinessIndexResponse, getCustomerHappinessIndexEndpoint } from 'cpie-common';

const CustomerHappinessIndexWithLoadingHandler = withLoadingAndNoConnectionHandler(CustomerHappinessIndexUi);

export const CustomerHappinessIndex: React.FC = () => {
    const { onAction } = useAnalyticsActionTracker('chi');

    const [isSurveyLoading, setIsSurveyLoading] = useState(false);
    const [isSurveyError, setIsSurveyError] = useState(false);
    const [surveyUrl, setSurveyUrl] = useState<string | null>(null);
    const [isModalShown, setIsModalShown] = useState(false);

    const handleButtonClick = () => {
        onAction();
        setIsSurveyLoading(true);

        CpDataApi.get<CustomerHappinessIndexResponse>(getCustomerHappinessIndexEndpoint())
            .then(response => {
                setIsSurveyLoading(false);
                setSurveyUrl(response.data?.redirectUrl || null);
                setIsModalShown(true);
                //window.open(response.data?.redirectUrl, '_blank');
            })
            .catch(() => {
                setIsSurveyLoading(false);
                setIsSurveyError(true);
                setIsModalShown(false);
            });
    };

    return (
        <>
            {isSurveyLoading && <Spinner fullPage />}
            <CustomerHappinessIndexWithLoadingHandler
                isLoading={false}
                hasError={isSurveyError}
                surveyUrl={surveyUrl || ''}
                isModalShown={isModalShown}
                handleOpenModal={handleButtonClick}
                handleCloseModal={() => setIsModalShown(false)}
            />
        </>
    );
};
